import SiteVisitReportForm from './ReportTemplateForm';

export default SiteVisitReportForm;
